import { render } from "./BouncingCircleScreen.vue?vue&type=template&id=97ec0176&scoped=true&ts=true"
import script from "./BouncingCircleScreen.vue?vue&type=script&lang=ts"
export * from "./BouncingCircleScreen.vue?vue&type=script&lang=ts"

import "./BouncingCircleScreen.vue?vue&type=style&index=0&id=97ec0176&scoped=true&lang=css"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97ec0176"]])

export default __exports__